import React from 'react';
import Select from 'react-select';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';
import Api from './Config';
import Alert from './Alert';
import BooleanAlert from './BooleanAlert';

export default class MessageTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalValue: { title: '', body: '', link: '', view_title: '' },
      apps: [],
      formMode: null,
      selected_club: null,
      templates: [],
      categories: [],
      reloadList: 0,
    };

    this.loadRows = this.loadRows.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.doDialogSave = this.doDialogSave.bind(this);
  }

  componentDidMount() {
    this.getApps();
    this.getCategories();
  }

  getApps() {
    Api.getApps()
      .then((apps) => {
        const allApps = _.map(apps, (a) => {
          a.clubname = unescape(a.clubname);
          return a;
        });

        this.setState({
          apps: allApps,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCategories() {
    Api.getAllTemplatesCategory()
      .then((categories) => {
        let options = categories.map((category) => ({
          label: category.name,
          value: category.id,
        }));
        this.setState({ categories: options });
      })
      .catch((err) => {
        this.alert.open('Error', `${err}`);
      });
  }

  itemSelected(obj) {
    this.setState({ selected_club: obj });
    this.setState({ reloadList: this.state.reloadList + 1 });
  }

  async loadRows(startIdx, queryAmount) {
    const results = await Api.getTemplates(this.state.selected_club.club_id, startIdx, queryAmount);

    let resultTemplates = results.data;
    if (startIdx > 0) {
      resultTemplates = this.state.templates.concat(resultTemplates);
    }
    this.setState({ templates: resultTemplates });

    return {
      data: results.data,
      maxRows: results.maxRows,
    };
  }

  doDialogSave() {
    if (
      this.state.modalValue.view_title.trim() === '' ||
      this.state.modalValue.title.trim() === '' ||
      this.state.modalValue.body.trim() === ''
    ) {
      this.alert.open('Error', 'Use, Title and body should be given');
      return;
    }

    let category_id = null;
    if (this.state.modalValue.category) {
      category_id = this.state.modalValue.category.value;
    }

    Api.addUpdateTemplate(
      this.state.selected_club.club_id,
      this.state.modalValue.view_title,
      this.state.modalValue.title,
      this.state.modalValue.body,
      this.state.modalValue.link,
      this.state.current_id,
      category_id,
      this.state.formMode
    )
      .then((data) => {
        if (data.SUCCESS === true) {
          this.setState({ formMode: null, reloadList: this.state.reloadList + 1 });
          return;
        }
        throw new Error(data.ERROR);
      })
      .catch((err) => {
        this.alert.open('Error', `${err}`);
      });
  }

  getTableCell({ dataKey, rowData }) {
    let cellItem;

    switch (dataKey) {
      case 'edit':
        cellItem = (
          <button
            onClick={() => {
              const category_select = this.state.categories.filter(
                (category) => category.value === rowData.category_id
              );
              this.setState({
                modalValue: {
                  link: rowData.link,
                  title: rowData.title,
                  body: rowData.body,
                  view_title: rowData.view_title,
                  category: category_select[0],
                },
                current_id: rowData.id,
                formMode: 'Edit',
              });
            }}
            type="button"
            className="btn btn-primary btn-sm"
          >
            Edit
          </button>
        );
        break;
      case 'delete':
        cellItem = (
          <button
            onClick={() => {
              this.booleanAlert.open('Confirm Delete', `Are you sure you want to delete ${rowData.title}?`, () => {
                Api.deleteTemplate(rowData.id)
                  .then(({ SUCCESS, ERROR }) => {
                    if (SUCCESS) {
                      this.setState({ templates: this.state.templates.filter((item) => item.id != rowData.id) });
                    } else {
                      this.alert.open('Error', `${ERROR}`);
                    }
                  })
                  .catch((err) => {
                    this.alert.open('Error', `${err}`);
                  });
              });
            }}
            type="button"
            className="bbt btn-danger btn-sm"
          >
            Delete
          </button>
        );
        break;
    }

    return cellItem;
  }

  getColumnStyle() {
    return { whiteSpace: 'normal' };
  }

  renderRows() {
    return (
      <InfiniteList lists={this.state.templates} loadRows={this.loadRows} reloadList={this.state.reloadList}>
        {({ onRowsRendered, registerChild, width }) => (
          <Table
            ref={registerChild}
            onRowsRendered={onRowsRendered}
            width={width}
            height={800}
            headerHeight={40}
            rowStyle={{
              borderBottom: '1px solid #ddd',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            rowCount={this.state.templates.length}
            rowGetter={({ index }) => this.state.templates[index]}
            rowHeight={80}
          >
            <Column label="Category" dataKey="category_name" width={width / 7} style={this.getColumnStyle()} />
            <Column label="Message Use" dataKey="view_title" width={width / 5} style={this.getColumnStyle()} />
            <Column label="Title" dataKey="title" width={width / 5} style={this.getColumnStyle()} />
            <Column label="Body" dataKey="body" width={width / 2} style={this.getColumnStyle()} />
            <Column label="Edit" dataKey="edit" cellRenderer={this.getTableCell} width={100} />
            <Column label="Delete" dataKey="delete" cellRenderer={this.getTableCell} width={100} />
          </Table>
        )}
      </InfiniteList>
    );
  }

  getEditForm() {
    return (
      <div className="modal show ">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">{this.state.formMode} Template</div>
            <div className="modal-body">
              <div className="form-group">
                <label>Category</label>
                <Select
                  value={this.state.modalValue.category}
                  options={this.state.categories}
                  onChange={(obj) => {
                    this.setState({ modalValue: { ...this.state.modalValue, category: obj } });
                  }}
                />
              </div>
              <div className="form-group">
                <label>Message Use</label>
                <input
                  maxLength={35}
                  value={this.state.modalValue.view_title}
                  onChange={(e) => {
                    this.setState({ modalValue: { ...this.state.modalValue, view_title: e.target.value } });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Alert that will appear on phone</label>
                <input
                  maxLength={35}
                  value={this.state.modalValue.title}
                  onChange={(e) => {
                    this.setState({ modalValue: { ...this.state.modalValue, title: e.target.value } });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Body</label>
                <b>-{this.state.modalValue.body.length}</b> of 200
                <textarea
                  maxLength={200}
                  value={this.state.modalValue.body}
                  onChange={(e) => {
                    if (e.target.value.length <= 200) {
                      this.setState({ modalValue: { ...this.state.modalValue, body: e.target.value } });
                    }
                  }}
                  type="text"
                  className="form-control"
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>
                  Link
                </label>
                <input
                  maxLength={200}
                  value={this.state.modalValue.link}
                  onChange={(e) => {
                    this.setState({ modalValue: { ...this.state.modalValue, link: e.target.value } });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={this.doDialogSave} type="button" className="btn btn-primary">
                Save
              </button>
              <button
                type="button"
                onClick={() => {
                  this.setState({ formMode: null });
                }}
                className="btn btn-info"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { selected_club, apps } = this.state;
    return (
      <div>
        {this.state.formMode && this.getEditForm()}
        <h3>Msg Template</h3>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Select App:</label>
            <Select
              onChange={(obj) => {
                this.itemSelected(obj);
              }}
              value={selected_club}
              getOptionValue={(a) => a.club_id}
              getOptionLabel={(a) => a.clubname}
              options={apps}
            />
          </div>
        </div>
        {this.state.selected_club && (
          <div>
            <button
              type="button"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.setState({ formMode: 'Add', modalValue: { title: '', body: '', link: '', view_title: '' } });
              }}
              className="btn btn-xs btn-primary"
            >
              Add New
            </button>
            {this.renderRows()}
          </div>
        )}
        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />
        <Alert
          ref={(ref) => {
            this.alert = ref;
          }}
        />
      </div>
    );
  }
}
